import { useTranslation } from "react-i18next";
import background from "@/config/assets/background.jpg";
import mohLogo from "@/config/assets/mohlogo.png";
import dhis2Logo from "@/config/assets/dhis2logo.png";
import useDashboardEn from "@/config/assets/usedashboarden.jpg";
import useDashboardLo from "@/config/assets/usedashboardlo.jpg";
import DashboardSelector from "@/components/ControlBar/DashboardSelector";
import "swiper/css";
import "./Home.css";
const Home = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="home-container">
      <div className="home-background">
        <img src={background} />
      </div>
      <div className="home-content">
        <div>
          <img src={mohLogo} />
          {/* <img src={dhis2Logo} /> */}
        </div>
        <div>
          <div className="home-title-container">{t("homeTitle")}</div>
          <div className="home-sub-title-container">{t("homeSubTitle")}</div>
          <br />
          <br />
          <div className="home-dashboard-selector-container">
            <div>
              <div className="selector-label">{t("pleaseSelectDashboard")}</div>
              <DashboardSelector />
            </div>
            <br />
            <div className="disclaimer-title-wrapper">
              <div className="disclaimer-title">{t("disclaimer")}</div>
              <i>{t("disclaimerSubTitle")}</i>
            </div>
            <div className="disclaimer-content-wrapper">
              <div className="disclaimer-title">{t("howToUseTitle")}</div>
              <div>{t("howToUseLine1")}</div>
              <div>{t("howToUseLine2")}</div>
              <img
                src={i18n.language === "en" ? useDashboardEn : useDashboardLo}
                alt="example image"
              />
              <div className="disclaimer-title">
                {t("whoIsDashboardForTitle")}
              </div>
              <div>{t("whoIsDashboardForLine1")}</div>
              <ul>
                <li>{t("whoIsDashboardForLine2")}</li>
                <li>{t("whoIsDashboardForLine3")}</li>
                <li>{t("whoIsDashboardForLine4")}</li>
              </ul>
              <div className="disclaimer-title">
                {t("howDashboardMadeTitle")}
              </div>
              <div>{t("howDashboardMadeLine1")}</div>
              <div className="disclaimer-title">{t("aboutSectionTitle")}</div>
              <div>{t("aboutSectionLine1")}</div>
              <div>{t("aboutSectionLine2")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
